export default "__VITE_ASSET__DeIi5gsT__"